export default {
  s3: {
    REGION: "us-west-2",
    BUCKET: process.env.REACT_APP_BUCKET
  },
  apiGateway: {
    REGION: "us-west-2",
    URL: ""
  },
  cognito: {
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_zNUG9kd9m",
    APP_CLIENT_ID: "5acgu01uq606uijqdqn6btm29n",
    IDENTITY_POOL_ID: "us-west-2:60087551-00fa-429b-9099-51726817ac23"
  },
  API: {
    endpoints: [
      {
        name: 'api',
        endpoint: process.env.REACT_APP_API_URL + 'api/',
        region: "us-west-2"
      },
      {
        name: 'app',
        endpoint: process.env.REACT_APP_API_URL + 'app/',
        region: "us-west-2"
      }
    ]
  }
};

export const STATUS = {
  pending: "Order Placed",
  uploaded: "Order Uploaded, Pending",
  processing: "In Process at Lab",
  shipped: "Shipped",
  error: "Error"
};

export const SHIPPING = {
  CA: 20,
  AU: 30,
  GB: 30,
  OTHER: 36
};

export const STATES = [
  { name: 'Alabama', abbrev: 'AL' },
  { name: 'Alaska', abbrev: 'AK' },
  { name: 'Arizona', abbrev: 'AZ' },
  { name: 'Arkansas', abbrev: 'AR' },
  { name: 'California', abbrev: 'CA' },
  { name: 'Colorado', abbrev: 'CO' },
  { name: 'Connecticut', abbrev: 'CT' },
  { name: 'Delaware', abbrev: 'DE' },
  { name: 'District of Columbia', abbrev: 'DC' },
  { name: 'Florida', abbrev: 'FL' },
  { name: 'Georgia', abbrev: 'GA' },
  { name: 'Hawaii', abbrev: 'HI' },
  { name: 'Idaho', abbrev: 'ID' },
  { name: 'Illinois', abbrev: 'IL' },
  { name: 'Indiana', abbrev: 'IN' },
  { name: 'Iowa', abbrev: 'IA' },
  { name: 'Kansas', abbrev: 'KS' },
  { name: 'Kentucky', abbrev: 'KY' },
  { name: 'Louisiana', abbrev: 'LA' },
  { name: 'Maine', abbrev: 'ME' },
  { name: 'Maryland', abbrev: 'MD' },
  { name: 'Massachusetts', abbrev: 'MA' },
  { name: 'Michigan', abbrev: 'MI' },
  { name: 'Minnesota', abbrev: 'MN' },
  { name: 'Mississippi', abbrev: 'MS' },
  { name: 'Missouri', abbrev: 'MO' },
  { name: 'Montana', abbrev: 'MT' },
  { name: 'Nebraska', abbrev: 'NE' },
  { name: 'Nevada', abbrev: 'NV' },
  { name: 'New Hampshire', abbrev: 'NH' },
  { name: 'New Jersey', abbrev: 'NJ' },
  { name: 'New Mexico', abbrev: 'NM' },
  { name: 'New York', abbrev: 'NY' },
  { name: 'North Carolina', abbrev: 'NC' },
  { name: 'North Dakota', abbrev: 'ND' },
  { name: 'Ohio', abbrev: 'OH' },
  { name: 'Oklahoma', abbrev: 'OK' },
  { name: 'Oregon', abbrev: 'OR' },
  { name: 'Pennsylvania', abbrev: 'PA' },
  { name: 'Rhode Island', abbrev: 'RI' },
  { name: 'South Carolina', abbrev: 'SC' },
  { name: 'South Dakota', abbrev: 'SD' },
  { name: 'Tennessee', abbrev: 'TN' },
  { name: 'Texas', abbrev: 'TX' },
  { name: 'Utah', abbrev: 'UT' },
  { name: 'Vermont', abbrev: 'VT' },
  { name: 'Virginia', abbrev: 'VA' },
  { name: 'Washington', abbrev: 'WA' },
  { name: 'West Virginia', abbrev: 'WV' },
  { name: 'Wisconsin', abbrev: 'WI' },
  { name: 'Wyoming', abbrev: 'WY' },
  { name: 'Puerto Rico', abbrev: 'PR' },
  { name: 'Guam', abbrev: 'GU' },
  { name: 'American Samoa', abbrev: 'AS' },
  { name: 'Virgin Islands', abbrev: 'VI' },
  { name: 'Northern Mariana Islands', abbrev: 'MP' }
];
